
const headMap = {
  luggage: {
    title: '差异化行李',
    icon: require('./img/extra-luggage-v2.png'),
    className: 'luggage',
    span: 6
  },
  meal: {
    title: '特色餐饮',
    icon: require('./img/extra-meal-v2.png'),
    className: 'meal',
    span: 8
  },
  insurance: {
    title: '保险',
    icon: require('./img/extra-insurance-v2.png'),
    className: 'insurance',
    span: 6
  },
  lugInsurance: {
    title: '行李险',
    icon: require('./img/extra-insurance-v2.png'),
    className: 'insurance',
    span: 6
  },
  viphall: {
    title: '贵宾厅',
    icon: require('./img/extra-guest-v2.png'),
    className: 'guest',
    span: 6
  },
  cardCoupon: {
    title: '卡券',
    icon: require('./img/extra-card-v2.png'),
    className: 'card',
    span: 6
  }
}
export {
  headMap
}
